export enum INTERNAL_STEPPER {
  START = 0,
  CONFIGURATION = 1,
}
